import React from "react";
import { motion } from "framer-motion";
import {
  LineChart,
  Line,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
// icons imports
import { IoSpeedometerSharp } from "react-icons/io5";

const UserActivityChart = ({ user }) => {
  const signInHistory = [
    { name: "Feb", signIn: 2 },
    { name: "Mar", signIn: 4 },
    { name: "Apr", signIn: 6 },
    { name: "May", signIn: 8 },
    { name: "Jun", signIn: 3 },
    { name: "Jul", signIn: 7 },
    { name: "Aug", signIn: 5 },
    { name: "Sep", signIn: 10 },
    { name: "Oct", signIn: 12 },
    { name: "Nov", signIn: 11 },
    { name: "Dec", signIn: 13 },
  ];

  return (
    <motion.div
      className="w-full mt-8 rounded-lg dark:bg-gray-800 bg-slate-50 "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Activity Chart */}
      <motion.div
        className="mt-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="flex flex-row items-center mb-4 text-lg font-semibold text-gray-700 dark:text-gray-300 gap-x-3">
          <IoSpeedometerSharp className="text-xl" />

          <span>User Activity</span>
        </h2>

        {/* Responsive ComposedChart */}
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={signInHistory}>
            <CartesianGrid stroke="#ccc" />
            <XAxis
              dataKey="name"
              label={{ value: "Month", position: "insideBottom", offset: -10 }}
            />
            <YAxis
              label={{ value: "Sign-ins", angle: -90, position: "insideLeft" }}
            />
            <Tooltip />
            <Legend />
            <Bar dataKey="signIn" barSize={20} fill="#413ea0" />
            <Line type="monotone" dataKey="signIn" stroke="#ff7300" />
          </LineChart>
        </ResponsiveContainer>
      </motion.div>
    </motion.div>
  );
};

export default UserActivityChart;
